import React, {Component} from 'react';
import { connect } from 'react-redux';
import {NavLink, withRouter} from 'react-router-dom';
import {Helmet} from "react-helmet";
import Http from '../../utils/http';
import './Blog.css';
class Blog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            featuredImage:'',
            contentHtml:'',
        };

    }

    componentWillMount() {}
    componentDidMount() {
    //   let blogId = this.props.location.state.blogId;
    //   let articlesId = this.props.location.state.articlesId;

    let blogId = this.props.match.params.blogId;
    let articlesId = this.props.match.params.articlesId;

      if(blogId && articlesId){
        this.fun_getBlogArticlesDetail(blogId,articlesId);
      }
    }

    fun_getBlogArticlesDetail(blogId,articleId){
        Http.get(`/api/blogs/${blogId}/articles/${articleId}`,false).then(Response =>{
            this.setState({
                title: Response.title,
                featuredImage: Response.featuredImage,
                contentHtml:Response.content,
            })
        }).catch(err =>{

        })
    }

    render() {
     
        return (
            <div className="home">
                {/* <Helmet>
                    <title>HelloAva - The Brains Behind Your Beauty</title>
                    <meta name="description" content="Discover the best skincare products for your skin's unique needs, powered by artificial intelligence and human expertise." />
                </Helmet> */}
                <div className="blog">
                    <div className="blog-content-datail-area">
                        <div className="blog-post-wrapper">
                            <article className="blog-post has-featured-image">
                                <img src={this.state.featuredImage} alt="Kai Tackles Post-Partum Hormonal Acne" class="highlight"/>
                                <div className="blog-post-inner" style={{paddingTop: '419.469px'}}>
                                    <h1 className="post-title">{this.state.title}</h1>
                                     <span className="post-date">&#160;</span>
                                    <div className="rte post-content" dangerouslySetInnerHTML={{__html:this.state.contentHtml}}></div>
                                </div>
                            </article>
                        </div>
                    </div>
                </div>
               
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { helloava } = state;
    const { isAuthenticated } = helloava.auth;
    return { isAuthenticated };
}

export default withRouter(connect(mapStateToProps, null)(Blog));



// WEBPACK FOOTER //
// ./src/views/blog/BlogDetail.js